import { render, staticRenderFns } from "./TableAssos.vue?vue&type=template&id=76c21b5a&"
import script from "./TableAssos.vue?vue&type=script&lang=js&"
export * from "./TableAssos.vue?vue&type=script&lang=js&"
import style0 from "./TableAssos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports